function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M512 256c0 141-115 256-256 256S0 397 0 256 115 0 256 0s256 115 256 256zm-219-37v-60c0-21-17-37-37-37s-37 16-37 37v60h-60c-21 0-37 17-37 37s16 37 37 37h60v60c0 21 17 37 37 37s37-16 37-37v-60h60c21 0 37-17 37-37s-16-37-37-37z"
})));